import { isNil, isEmpty } from 'lodash';

export default {
  name: 'quiz-options-controls',

  props: {
    correctAnswerId: {
      type: Number,
      default: null,
    },
    answerId: {
      type: Number,
      default: null,
    },
    isSolvedQuiz: {
      type: Boolean,
      default: false,
    },
    onOptionClick: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      selectedOption: null,
    };
  },

  methods: {
    getOptionClassName(option) {
      if (!this.isSolvedQuiz && this.isSelected(option)) {
        return { selected: this.isSelected(option) };
      }

      if (this.isSolvedQuiz) {
        return {
          correct: this.isCorrect(option),
          incorrect: this.isIncorrect(option),
        };
      }

      return {};
    },

    handleOptionClick(option) {
      if (this.isSolvedQuiz) {
        return;
      }

      this.selectedOption = option;
      this.onOptionClick(option);
    },

    isSelected(option) {
      if (!this.isSolvedQuiz && isEmpty(this.selectedOption)) {
        return false;
      }

      return this.selectedOption.id === option.id;
    },

    isCorrect(option) {
      if (this.isSolvedQuiz && !isNil(this.correctAnswerId)) {
        return this.correctAnswerId === option.id;
      }

      return option.is_correct;
    },

    isIncorrect(option) {
      return this.isSolvedQuiz
        && (this.answerId === option.id)
        && !this.isCorrect(option)
        && !option.is_correct;
    },
  },
};
